import { render, staticRenderFns } from "./fp-cart.vue?vue&type=template&id=2ed724c3&"
import script from "./fp-cart.vue?vue&type=script&lang=js&"
export * from "./fp-cart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ed724c3')) {
      api.createRecord('2ed724c3', component.options)
    } else {
      api.reload('2ed724c3', component.options)
    }
    module.hot.accept("./fp-cart.vue?vue&type=template&id=2ed724c3&", function () {
      api.rerender('2ed724c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/fp-cart.vue"
export default component.exports